import { useCallback, useMemo } from 'react';
import { getCountry, getMerchant, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getPublicIntegrationKey } from '@tectonics/prs/merchant';
import { sendGA4Event } from './send-ga4-event';

export function useTrackPaymentMethodSelected(): (selectedMethod: string) => void {
  const incomingPayment = useIncomingPayment();

  const merchantId = useMemo(() => {
    try {
      return getPublicIntegrationKey(getMerchant(incomingPayment));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('GA4 merchantId extraction error:', e);
      return '';
    }
  }, [incomingPayment]);

  const country = getCountry(incomingPayment);

  return useCallback((selectedMethod: string) => {
    try {
      sendGA4Event('payment_method_selected', {
        payment_method: selectedMethod,
        merchant_id: merchantId,
        checkout_country: country,
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('GA4 payment_method_selected error:', e);
    }
  }, [merchantId, country]);
}
